module.exports = __webpack_public_path__ + "media/images/prizes/icon_points-9d0db2939b57602d88bd373367277323.svg";